import { Answer } from 'pages/ParentHelper/components/Chat/components/Body/components/Answer';
import { Skeleton as SkeletonItem } from 'shared/components/Skeleton';

import type { FC } from 'react';

export const Skeleton: FC = () => (
  <>
    <Answer
      answer={<SkeletonItem width={65} height={24} />}
      withoutAvatar
      withoutFeedback
      messageId="bot1"
    />
    <Answer
      answer={<SkeletonItem width={189} height={24} />}
      messageId="bot2"
      withoutFeedback
    />
  </>
);
